'use client';

import { useEffect } from 'react';
import { trackActivity, recordToolView } from '@/app/actions/track-activity';

export default function ToolViewTracker({ toolId, currentCount }: { toolId: string; currentCount: number }) {
  useEffect(() => {
    trackActivity('view', toolId).catch(() => {});
    recordToolView(toolId, currentCount).catch(() => {});
  }, [toolId, currentCount]);

  return null;
}
